module.exports = __webpack_public_path__ + "static/img/BK6.def275c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/BK6.png
// module id = HBe+
// module chunks = 9